/**
 * Normalizes ABI Entry Summary line items PGA data structure
 * Ensures vehiclesAndEngines array is initialized for VNE-related PGA items
 * 
 * @param {Array} lineItems - Array of line item objects
 * @returns {Array} Normalized line items with initialized vehiclesAndEngines
 */
export const normalizeLineItemsPgaData = (lineItems) => {
  if (!Array.isArray(lineItems)) {
    return lineItems
  }

  return lineItems.map((lineItem, idx) => {
    if (!lineItem.pgaList || !Array.isArray(lineItem.pgaList)) {
      return lineItem
    }

    const normalizedPgaList = lineItem.pgaList.map((pgaItem) => {
      // Check if this is a VNE-related PGA
      const isVnePga = 
        pgaItem?.agencyCode === 'EPA' || 
        pgaItem?.agencyCode === 'EP' ||
        (pgaItem?.tariffFlagCode && ['EP3', 'EP4'].some(code => pgaItem.tariffFlagCode?.includes(code)))

            // Initialize vehiclesAndEngines if it's a VNE PGA and the field is missing/empty
      if (isVnePga && (!pgaItem.vehiclesAndEngines || pgaItem.vehiclesAndEngines.length === 0)) {
        return {
          ...pgaItem,
          vehiclesAndEngines: [{ vneComponents: [] }]
        }
      }

      return pgaItem
    })

    return {
      ...lineItem,
      pgaList: normalizedPgaList
    }
  })
}

/**
 * Normalizes a single line item's PGA data
 * 
 * @param {Object} lineItem - Single line item object
 * @returns {Object} Normalized line item
 */
export const normalizeSingleLineItemPgaData = (lineItem) => {
  if (!lineItem || !lineItem.pgaList || !Array.isArray(lineItem.pgaList)) {
    return lineItem
  }

  const normalizedPgaList = lineItem.pgaList.map(pgaItem => {
    const isVnePga = 
      pgaItem?.agencyCode === 'EPA' || 
      pgaItem?.agencyCode === 'EP' ||
      (pgaItem?.tariffFlagCode && ['EP3', 'EP4'].some(code => pgaItem.tariffFlagCode?.includes(code)))

    if (isVnePga && (!pgaItem.vehiclesAndEngines || pgaItem.vehiclesAndEngines.length === 0)) {
      return {
        ...pgaItem,
        vehiclesAndEngines: [{ vneComponents: [] }]
      }
    }

    return pgaItem
  })

  return {
    ...lineItem,
    pgaList: normalizedPgaList
  }
}